import React, { useRef } from 'react';
import { ProfileContent } from './common';

const Basic = ({ profile, currentProfile }) => {
  const linkEmailRef = useRef(null);

  const handleAskInformation = () => linkEmailRef.current.click();

  return (
    <>
      <a
        href={`mailto:digitalinfo@salonemilano.it`}
        target="_blank"
        rel="noreferrer"
        hidden
        ref={linkEmailRef}
      />
      <ProfileContent
        onAskInformation={() => handleAskInformation()}
        profile={profile}
        currentProfile={currentProfile}
      />
    </>
  );
};

export { Basic };
